import { useNavigate } from "react-router-dom";
import { ROLE_CONFIG } from "./RolesTab";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";

const NotificationTableRow = ({ notification }) => {
  const navigate = useNavigate();
  const { currentUser } = useTenantAuth();
  const role = currentUser?.role_slug;
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Truncate description if too long
  const truncateText = (text, maxLength = 80) => {
    if (!text) return "-";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  const handleView = () => {
    const baseRoute = ROLE_CONFIG[role]?.notification?.view;
    if (baseRoute) {
      navigate(`${baseRoute}/${notification.batch_id}`);
    } else {
      navigate(`/notification/${notification.batch_id}`);
    }
  };

  return (
    <tr>
      <td className="notification-col-title">{notification.title || "-"}</td>
      <td className="notification-col-desc">{truncateText(notification.description)}</td>
      <td className="notification-col-date text-nowrap">{formatDate(notification.created_at)}</td>
      <td className="notification-col-action text-center">
        <button
          onClick={handleView}
          className="notification-table-view-btn"
          style={{
            backgroundColor: "black",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          View
        </button>
      </td>
    </tr>
  );
};

export default NotificationTableRow;
